import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import "react-phone-input-2/lib/style.css";
import FormHeader from "../../../Common/components/templates/formHeader";
import FormDirections from "../../../Common/components/templates/formDirections";
import PrimaryButton from "../../../Common/components/templates/buttons/primary";
import { globalConfig } from "../../../Common/configuration/config";
import { FormattedMessage, useIntl } from "react-intl";
import { getLocale } from "../../../Common/localization/localizationHelper";

const ResetMfaVerification = (props: any) => {
    const history = useHistory();
    const location = useLocation();
    const config = globalConfig.get();

    const getTokenFromUrl = () => {
        const params = new URLSearchParams(location.search);
        return params.get("token");
    };

    const handleButtonClick = async () => {
        const token = getTokenFromUrl();
        if (token) {
            try {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", `Bearer ${token}`);
                myHeaders.append("Content-Type", "application/json");

                const requestOptions: RequestInit = {
                    method: 'POST',
                    headers: myHeaders,
                    body: JSON.stringify({}),
                    redirect: 'follow' as RequestRedirect
                };

                const response = await fetch(`${config.ApiUrl}/api/v1/profile/reset-mfa`, requestOptions);

                if (response.ok) { 
                        const locale = getLocale();
                        let search;
                        if (locale) {
                            search = `?ui_locales=${locale}`;
                        }
                        history.push({
                            pathname: '/reset-successful',
                            search
                        });
                    // Successful request, redirect to reset-successful
                }

            } catch (error) {
                console.error('Error resetting MFA:', error);
            }
        }
    };

    return (
        <form className="form">
            <FormHeader title={useIntl()?.messages["mfa.resetVerification.header"]} />
            <div className="content">
                <FormDirections>
                    <FormattedMessage id="mfa.resetVerification.description"></FormattedMessage>
                </FormDirections>
                <div className="buttons">
                    <PrimaryButton
                        variant="contained"
                        color="primary"
                        onClick={handleButtonClick}
                    >
                        <FormattedMessage id="mfa.resetVerfication.button.Resetmfa"></FormattedMessage>
                    </PrimaryButton>
                </div>
            </div>
        </form>
    );
};

export default ResetMfaVerification;
